import { createAction } from '@reduxjs/toolkit';

export const DELETE_ANSWERING_RULE_ACTION_TYPE = 'saga/deleteAnsweringRule';
export const deleteAnswerRuleAction = createAction(DELETE_ANSWERING_RULE_ACTION_TYPE);
